module.exports = __webpack_public_path__ + "media/camera.98dcbdbc.svg";